import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ExchangePointsService } from '../../../../graphql/exchange-points/exchange-points.definition';
import { Points } from 'src/app/model/points';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { BaseComponent } from 'src/app/base/base.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-exchange-points',
  templateUrl: './exchange-points.component.html',
  styleUrls: ['./exchange-points.component.scss'],
})
export class ExchangePointsComponent extends BaseComponent implements OnInit {
  tableIdVisible: boolean = true;
  isModalVisible: boolean = false;
  pointsHistory: Points[] = [];
  searchInput: string = '';
  filteredPointsHistory: Points[] = [];
  itemOfViewDetails: Points | undefined;

  employeeId: string = '';

  constructor(
    public router: Router,
    public translate: TranslateService,
    private exchangePointsService: ExchangePointsService
  ) {
    super(router, translate);
  }

  ngOnInit(): void {
    this.getEmployeeId();
    this.fetchBuyMovPoints(this.employeeId);
  }

  getEmployeeId() {
    this.employeeId = localStorage.getItem('employeeId');
  }

  fetchBuyMovPoints(employeeId: string) {
    this.exchangePointsService.extractBuyMovPoints(employeeId).subscribe(
      (result: any) => {
        const buyMovs = result?.data?.extractBuyMovPoints?.buyMovs || [];
        this.pointsHistory = buyMovs.map((buyMov: any) => ({
          id: buyMov.id,
          status: buyMov.status,
          valuePoint: buyMov.valuePoint,
          buyDate: buyMov.buyDate,
          employeeId: buyMov.employee.id,
          employeeName: buyMov.employee.name,
          awardItems: buyMov.buyItems.map((item: any) => ({
            awardName: item.award.name,
            awardValue: item.award.value,
            buyQuantity: item.quantity,
            buyValue: item.value,
          })),
        }));
        this.filteredPointsHistory = this.pointsHistory;
      },
      () => {}
    );
  }

  openDetailsModal(id: string): void {
    this.itemOfViewDetails = this.pointsHistory.find((item) => item.id === id);

    this.showModal('modalDetails');
  }

  onSearch() {
    if (this.searchInput.trim() === '') {
      this.filteredPointsHistory = this.pointsHistory;
    } else {
      this.filteredPointsHistory = this.pointsHistory.filter((point) =>
        point.awardItems?.some((item) =>
          item.awardName.toLowerCase().includes(this.searchInput.toLowerCase())
        )
      );
    }
  }

  onChangeTableVisibility() {
    this.tableIdVisible = !this.tableIdVisible;
  }

  requestCancellation(buyMovId: string) {
    this.exchangePointsService.requestCancellation(buyMovId).subscribe(
      () => {
        this.showMessage(
          'Sucesso',
          'Cancelamento Solicitado com Sucesso',
          'success'
        );
        setTimeout(() => {
          location.reload();
        }, 1000);
      },
      () => {
        this.showMessage('Atenção', 'Erro ao solicitar cancelamento', 'error');
      }
    );
  }

  translateStatus(status: string) {
    switch (status) {
      case 'Cancellation request':
        return 'Cancelamento solicitado';
      case 'Pending':
        return 'Pendente';
      case 'Completed':
        return 'Entregue';
      case 'Canceled':
        return 'Cancelado';
      default:
        return '';
    }
  }

  formatStatus(status: string) {
    switch (status) {
      case 'Cancellation request':
        return 'cancellation-request';
      case 'Pending':
        return 'pending';
      case 'Completed':
        return 'completed';
      case 'Canceled':
        return 'canceled';
      default:
        return '';
    }
  }
}
